export default "__VITE_ASSET__C9DMZV9D__"